import { render, staticRenderFns } from "./DBIncome.vue?vue&type=template&id=2514990c&"
import script from "./DBIncome.vue?vue&type=script&lang=js&"
export * from "./DBIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports